// extracted by mini-css-extract-plugin
export default {"background":"Gradient_background__+mPq+","content":"Gradient_content__mw7m3","query":"Gradient_query__nJ3WR","inverted":"Gradient_inverted__Y9MTv","count":"Gradient_count__pGh5h"};